"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWalletProvider = void 0;
const ethers_1 = require("ethers");
function isWalletProvider(provider) {
    let result = false;
    if (provider) {
        switch (typeof provider) {
            case 'string':
                result = ethers_1.utils.isHexString(provider, 32);
                break;
            case 'object':
                const { privateKey } = provider;
                if (ethers_1.utils.isHexString(privateKey, 32)) {
                    result = true;
                }
                else {
                    const { type, signMessage } = provider;
                    result = !!type && typeof signMessage === 'function';
                }
                break;
        }
    }
    return result;
}
exports.isWalletProvider = isWalletProvider;
